import { render, staticRenderFns } from "./customer-farm.vue?vue&type=template&id=055c3214&scoped=true&"
import script from "./customer-farm.vue?vue&type=script&lang=js&"
export * from "./customer-farm.vue?vue&type=script&lang=js&"
import style0 from "./customer-farm.vue?vue&type=style&index=0&id=055c3214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c3214",
  null
  
)

export default component.exports